import EcoMode from '../lib/EcoMode';
import Dispatch from '../core/Dispatch';
import { USER_PREFERENCES_UPDATED } from '../lib/events';

export default (el, props) => {
    let clickHandler;

    const init = () => {
        el.setAttribute('aria-pressed', EcoMode.getPrefs().ecoMode === 'on' ? 'true' : 'false');

        clickHandler = e => {
            e.preventDefault();

            const newMode = el.getAttribute('aria-pressed') === 'true' ? 'false' : 'true';
            el.setAttribute('aria-pressed', newMode);

            EcoMode.setPrefs({ ecoMode: newMode === 'true' ? 'on' : 'off' });
        };

        el.addEventListener('click', clickHandler);
        
        Dispatch.on(USER_PREFERENCES_UPDATED, onPreferencesUpdated);
    };

    const destroy = () => {
        // Clean up event listeners if needed
        if (clickHandler) {
            el.removeEventListener('click', clickHandler);
            clickHandler = null;
        }
    };
    
    const onPreferencesUpdated = () => {
        el.setAttribute('aria-pressed', EcoMode.getPrefs().ecoMode === 'on' ? 'true' : 'false');
    };

    return {
        init,
        destroy
    };
};
